import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls to top on route change. If the URL contains a hash, scroll to the
 * matching element instead (after the page has rendered).
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.startsWith("#") ? hash.slice(1) : hash;
      // Double rAF + small fallback timeout to wait for layout on long pages
      let attempts = 0;
      const tryScroll = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "auto", block: "start" });
          // Re-anchor once more after the next paint, in case of late layout shifts
          requestAnimationFrame(() => {
            const again = document.getElementById(id);
            if (again) again.scrollIntoView({ behavior: "auto", block: "start" });
          });
          return;
        }
        if (attempts++ < 20) {
          setTimeout(tryScroll, 40);
        } else {
          window.scrollTo({ top: 0, behavior: "auto" });
        }
      };
      requestAnimationFrame(() => requestAnimationFrame(tryScroll));
    } else {
      window.scrollTo({ top: 0, behavior: "auto" });
    }
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
